"use strict";
export var TradeType = /* @__PURE__ */ ((TradeType2) => {
  TradeType2["EXACT_INPUT"] = "EXACT_INPUT";
  TradeType2["EXACT_OUTPUT"] = "EXACT_OUTPUT";
  return TradeType2;
})(TradeType || {});
